module.exports = __webpack_public_path__ + "static/media/close.71e6db29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close.svg
// module id = 274
// module chunks = 0